import React from 'react';
import { Image, TouchableOpacity } from 'react-native';
import { getSwitcherButtonImage } from '../../../utils/ImagesManagementUtils';

//= ========================================================================

const SwitcherButton = ({
  value, onValueChanged, alwaysOn, forceDisable,
}) => (
  <TouchableOpacity
    onPress={() => {
      onValueChanged(!value);
    }}
    disabled={alwaysOn || forceDisable}
  >
    <Image
      fadeDuration={0}
      style={{ width: 44, height: 22 }}
      source={getSwitcherButtonImage(value, alwaysOn, forceDisable)}
    />
  </TouchableOpacity>
);
export default SwitcherButton;
